import posthog from 'posthog-js';
import { useFeatureFlagEnabled, useFeatureFlagPayload } from 'posthog-js/react';

type FeatureFlag = 'image-rendering' | 'hide-sidebar-parts' | 'tenant-branding' | (string & {});

export function useFlag(flag: FeatureFlag) {
  const value = useFeatureFlagEnabled(flag);

  return value ?? !import.meta.env.PROD;
}

export function useFlagPayload<T extends object>(flag: FeatureFlag) {
  const payload = useFeatureFlagPayload(flag) as T;

  return payload;
}

export function getFlag(flag: FeatureFlag) {
  const value = posthog.isFeatureEnabled(flag);

  return value ?? !import.meta.env.PROD;
}
